export default "__VITE_ASSET__Czl8F6cI__"